import React from "react";
import { Box, Typography, Button, IconButton, Grid } from "@mui/material";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import RepeatIcon from "@mui/icons-material/Repeat";
import { useNavigate } from "react-router-dom";

const NoclassesScreen = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        mx: { xs: 2, sm: 5, md: 10 },
        my: 8,

        p: 8,
        px: { xs: 2, sm: 7, md: 15 },
        textAlign: "center",
        borderRadius: 4,
        backgroundColor: "#fff",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        position: "relative",
      }}
    >
      <Box
        position="absolute"
        top={0}
        right={0}
        sx={{
          width: "90px",
          borderTopLeftRadius: "2px",
          borderTopRightRadius: "15px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9240 (1).png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Box
        position="absolute"
        bottom={0}
        left={0}
        sx={{
          width: "90px",
          borderBottomRightRadius: "2px",
          borderBottomLeftRadius: "15px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9241 (1).png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box
            sx={{
              width: 60,
              height: 60,
              mx: "auto",
              mb: 2,
              borderRadius: "50%",
              backgroundColor: "#9D03850F",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ContentPasteSearchIcon sx={{ color: "#b80089" }} />
          </Box>
        </Grid>

        {/* Title */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="26px"
            color="#9D0385"
            sx={{
              fontWeight: 700,
              fontFamily: "Inters",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: "100%",
            }}
          >
            No Running Class Found
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="16px"
            color="#555555"
            sx={{
              fontWeight: 400,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: 1.5,
            }}
          >
            We couldn't find any active classes matching your search. The class
            might not be currently running, or may be offered in a different
            term.
          </Typography>
        </Grid>

        {/* Button */}
        {/* <Grid item xs={12} mt={2}>
          {" "}
          <Button
            variant="contained"
            color="secondary"
            startIcon={<RepeatIcon />}
            onClick={() => navigate("/test-prep/classes")}
            style={{
              background: "#9D0385",
              fontWeight: 500,
              borderRadius: "8px",
              fontSize: "16px",
              paddingLeft: 20,
              paddingRight: 20,
              fontFamily: "Inter",
              height: "32px",
              color: "#ffffff",
              "&:hover": {
                textDecoration: "none",
              },
            }}
            sx={{
              width: {
                xs: "100%", // full width on small screens
                sm: "60%", // 48% from 'sm' breakpoint and up
                md: "40%",
              },
            }}
          >
            Try Different keywords
          </Button>{" "}
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default NoclassesScreen;
